export default __webpack_public_path__ + "static/media/duration.1782d051.png";